import { InjectionToken } from "@angular/core";

export interface IncidentEndpoints {
    createTask: string;
    createArea: string;
    assignAreaToTask: string;
}

export const INCIDENT_ENDPOINTS = new InjectionToken<IncidentEndpoints>("Incident endpoints");
